import dialogs from "@mixins/includes/_dialogs";

let statusIconDialog = {
    mixins:[dialogs],
    methods: {
        openIconInfoDialog(){
            this.openDialog({type:'statusIconInfo'})
        }
    }
};

export default statusIconDialog;
